import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import BoardColumn from './BoardColumn';
import './ProjectTaskBoard.css';

const ProjectTaskBoard = ({ tasks, onStatusChange, onTaskClick, onShowTaskDetails, onEditTask, onDeleteTask, onCreateTask, onCreateSubtask, onOpenChat, onOpenUploadDocs }) => {
    // Group tasks by status
    const columns = {
        'todo': {
            title: 'To Do',
            tasks: tasks.filter(t => t.status === 'todo' && !t.parent_task_id),
            statusClass: 'column-todo'
        },
        'in_progress': {
            title: 'In Progress',
            tasks: tasks.filter(t => t.status === 'in_progress' && !t.parent_task_id),
            statusClass: 'column-in-progress'
        },
        'reopen': {
            title: 'Reopened',
            tasks: tasks.filter(t => t.status === 'reopen' && !t.parent_task_id),
            statusClass: 'column-reopen'
        },
        'on_hold': {
            title: 'Hold',
            tasks: tasks.filter(t => t.status === 'on_hold' && !t.parent_task_id),
            statusClass: 'column-hold'
        },
        'done': {
            title: 'Completed',
            tasks: tasks.filter(t => t.status === 'done' && !t.parent_task_id),
            statusClass: 'column-done'
        }
    };

    const handleDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) return;

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        // Logic for changing task status
        if (source.droppableId !== destination.droppableId) {
            onStatusChange(parseInt(draggableId), destination.droppableId);
        }
    };

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <div className="project-task-board">
                {Object.entries(columns).map(([columnId, column]) => (
                    <BoardColumn
                        key={columnId}
                        id={columnId}
                        title={column.title}
                        tasks={column.tasks}
                        statusClass={column.statusClass}
                        onStatusChange={onStatusChange}
                        onTaskClick={onTaskClick}
                        onShowTaskDetails={onShowTaskDetails}
                        onEditTask={onEditTask}
                        onDeleteTask={onDeleteTask}
                        onCreateTask={onCreateTask}
                        onCreateSubtask={onCreateSubtask}
                        onOpenChat={onOpenChat}
                        onOpenUploadDocs={onOpenUploadDocs}
                    />
                ))}
            </div>
        </DragDropContext>
    );
};

export default ProjectTaskBoard;
